import { TFunction } from 'i18next';

export const getFieldLabel = (fieldName: string, t: TFunction): string => {
  const fieldMap: Record<string, string> = {
    // Biométrie
    sexe: 'Sexe',
    taille: 'Taille en cm',
    dateNaissance: 'Date de naissance',
    photicEffect: 'Effets photiques',
    glasses: 'Indépendance aux lunettes',
    etatControlateral: "État de l'œil controlatéral",
    courbeDefocus: 'Courbe de défocus',
    bump: 'Bump',
    larmes: 'Larmes',
    longueurAxiale: 'Longueur axiale',
    // Vrais noms de champs
    endothelium: 'Cornée - Endothelium',
    diametrePupillaire: 'Diamètre pupillaire',
    aberrationOrdreEleve: "Cornée - Aberration d'ordre élevé",
    aberrationSpherique: 'Cornée - Aberration sphérique',
    retineNerfOptique: 'Rétine et/ou nerf optique',
    
    // Habitudes
    tempsEveil: "Temps d'éveil",
    heureReveil: 'Heure de réveil',
    heureCoucher: 'Heure de coucher',
    tempsSieste: 'Temps de sieste',
    visionPres: 'Vision de près',
    tempsLecture: 'Temps de lecture par jour',
    tempsTablette: 'Temps de tablette par jour',
    tempsSmartphone: 'Temps de smartphone par jour',
    tempsAutreVisionPres: "Temps d'autres activités de vision de près par jour",
    visionIntermediaire: 'Vision intermédiaire',
    tempsDiscussion: 'Temps de discussion par jour',
    tempsJeuxSociete: 'Temps de jeux de société par jour',
    tempsOrdinateur: "Temps d'utilisation de l'ordinateur par jour",
    tempsCuisine: 'Temps de cuisine par jour',
    visionLoin: 'Vision de loin',
    tempsConduite: 'Temps de conduite par jour',
    tempsTelevision: 'Temps de télévision par jour',
    activitesPreferentielles: 'Activités préférentielles',
    activitePreferentielleName: 'Activité préférentielle',
    activitePreferentielleDistanceMin: 'Distance minimum',
    activitePreferentielleDistanceMax: 'Distance maximum',
    
    // Implants
    compareImplants: 'Comparaison des implants',
    implantsFavoris: 'Implants favoris',
    typeImplant: "Type d'implant",
    materiauImplant: "Matériau de l'implant",
    laboratoireImplant: 'Laboratoire',
    selectionImplant: 'Sélection implant',
    decalageCourbe: "Décalage de la courbe de l'œil à opérer",
    affichageDefocus: "Afficher la courbe de l'œil déjà opéré",
    decalageCourbeExistante: "Amétropie de l'œil déjà opéré (SE)",
    lunettesVL: 'Vision de loin',
    lunettesVI: 'Vision intermédiaire',
    lunettesVP: 'Vision de près',

    // Interface patient (suffixe Patient)
    sexePatient: 'Sexe',
    taillePatient: 'Taille en cm',
    dateNaissancePatient: 'Date de naissance',
    photicEffectPatient: 'Effets photiques',
    glassesPatient: 'Indépendance aux lunettes',
    heureReveilPatient: 'Heure de réveil',
    heureCoucherPatient: 'Heure de coucher',
    tempsSiestePatient: 'Temps de sieste',
    tempsLecturePatient: 'Temps de lecture par jour',
    tempsTablettePatient: 'Temps de tablette par jour',
    tempsSmartphonePatient: 'Temps de smartphone par jour',
    tempsAutreVisionPresPatient: "Temps d'autres activités de vision de près par jour",
    tempsDiscussionPatient: 'Temps de discussion par jour',
    tempsJeuxSocietePatient: 'Temps de jeux de société par jour',
    tempsOrdinateurPatient: "Temps d'utilisation de l'ordinateur par jour",
    tempsCuisinePatient: 'Temps de cuisine par jour',
    tempsConduitePatient: 'Temps de conduite par jour',
    tempsTelevisionPatient: 'Temps de télévision par jour',
    activitePreferentiellePatient: 'Activité préférentielle',
    activitePreferentielleDistanceMinPatient: 'Distance minimum',
    activitePreferentielleDistanceMaxPatient: 'Distance maximum',
  };

  const labelKey = fieldMap[fieldName];
  return labelKey ? t(labelKey) : fieldName;
};
